import { Vector3, Box3, Sphere, Matrix4, Quaternion } from 'three';

class PerspectiveFrustumPointFitter {
  constructor() {
    this._sphere = new Sphere();
    this._box = new Box3();
  }

  fit_points(points, rotation, fov, aspect) {
    // Compute bounding sphere of all points
    this._box.makeEmpty();
    for (let i = 0; i < points.length; i++) {
      this._box.expandByPoint(points[i]);
    }
    this._box.getBoundingSphere(this._sphere);

    const center = this._sphere.center;
    const radius = this._sphere.radius;

    // Compute distance to fit sphere in frustum
    const fovRad = (fov * Math.PI) / 180;
    const halfFov = fovRad / 2;
    const distH = radius / Math.sin(halfFov);
    const distW = radius / Math.sin(Math.atan(Math.tan(halfFov) * aspect));
    const distance = Math.max(distH, distW);

    // Apply rotation to get camera direction
    const dir = new Vector3(0, 0, 1);
    if (rotation) {
      const q = new Quaternion().setFromEuler(rotation);
      dir.applyQuaternion(q);
    }

    const position = center.clone().add(dir.multiplyScalar(distance));

    return position;
  }
}

class OrthographicFrustumPointFitter {
  constructor() {
    this._sphere = new Sphere();
    this._box = new Box3();
  }

  fit_points(points, rotation, fov, aspect) {
    this._box.makeEmpty();
    for (let i = 0; i < points.length; i++) {
      this._box.expandByPoint(points[i]);
    }
    this._box.getBoundingSphere(this._sphere);

    return {
      center: this._sphere.center.clone(),
      distance_to_center: this._sphere.radius,
    };
  }
}

export { PerspectiveFrustumPointFitter, OrthographicFrustumPointFitter };
